export const genderOptions = [
    { value: 'female', label: 'Female' },
    { value: 'male', label: 'Male' },
    { value: 'other', label: 'Other' },
];

export const languageOptions = [
    { value: 'Arabic', label: 'Arabic' },
    { value: 'Czech', label: 'Czech' },
    { value: 'Danish', label: 'Danish' },
    { value: 'Dutch', label: 'Dutch' },
    { value: 'English', label: 'English' },
    { value: 'Finnish', label: 'Finnish' },
    { value: 'French', label: 'French' },
    { value: 'German', label: 'German' },
    { value: 'Greek', label: 'Greek' },
    { value: 'Hindi', label: 'Hindi' },
    { value: 'Hungarian', label: 'Hungarian' },
    { value: 'Italian', label: 'Italian' },
    { value: 'Japanese', label: 'Japanese' },
    { value: 'Korean', label: 'Korean' },
    { value: 'Mandarin', label: 'Mandarin' },
    { value: 'Norwegian', label: 'Norwegian' },
    { value: 'Polish', label: 'Polish' },
    { value: 'Portuguese', label: 'Portuguese' },
    { value: 'Russian', label: 'Russian' },
    { value: 'Spanish', label: 'Spanish' },
    { value: 'Swedish', label: 'Swedish' },
    { value: 'Thai', label: 'Thai' },
    { value: 'Turkish', label: 'Turkish' },
    { value: 'Vietnamese', label: 'Vietnamese' },
];

export const countryOptions = [
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'Canada', label: 'Canada' },
    { value: 'China', label: 'China' },
    { value: 'Colombia', label: 'Colombia' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Greece', label: 'Greece' },
    { value: 'India', label: 'India' },
    { value: 'Indonesia', label: 'Indonesia' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Mexico', label: 'Mexico' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Nigeria', label: 'Nigeria' },
    { value: 'Norway', label: 'Norway' },
    { value: 'Pakistan', label: 'Pakistan' },
    { value: 'Philippines', label: 'Philippines' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Portugal', label: 'Portugal' },
    { value: 'Russia', label: 'Russia' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'South Korea', label: 'South Korea' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'Thailand', label: 'Thailand' },
    { value: 'Turkey', label: 'Turkey' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Vietnam', label: 'Vietnam' },
];

export const eyeColorOptions = [
    { value: 'blue', label: 'Blue' },
    { value: 'dark_blue', label: 'Dark Blue' },
    { value: 'light_blue', label: 'Light Blue' },
    { value: 'grayish_blue', label: 'Grayish Blue' },

    { value: 'green', label: 'Green' },
    { value: 'dark_green', label: 'Dark Green' },
    { value: 'light_green', label: 'Light Green' },
    { value: 'grayish_green', label: 'Grayish Green' },

    { value: 'brown', label: 'Brown' },
    { value: 'dark_brown', label: 'Dark Brown' },
    { value: 'light_brown', label: 'Light Brown' },
    { value: 'golden_brown', label: 'Golden Brown' },

    { value: 'black', label: 'Black' },

    { value: 'hazel', label: 'Hazel' },
    { value: 'golden_hazel', label: 'Golden Hazel' },
    { value: 'green_hazel', label: 'Green Hazel' },

    { value: 'gray', label: 'Gray' },
    { value: 'dark_gray', label: 'Dark Gray' },
    { value: 'light_gray', label: 'Light Gray' },
    { value: 'blue_gray', label: 'Blue-Gray' },
    { value: 'green_gray', label: 'Green-Gray' },

    { value: 'amber', label: 'Amber' },
    { value: 'golden_amber', label: 'Golden Amber' },

    { value: 'red', label: 'Red' },
    { value: 'violet', label: 'Violet' },

    { value: 'heterochromia', label: 'Heterochromia' },
    { value: 'central_heterochromia', label: 'Central Heterochromia' },
    { value: 'sectoral_heterochromia', label: 'Sectoral Heterochromia' },

    { value: 'other', label: 'Other / Miscellaneous' }
];


export const hairColorOptions = [
    { value: 'black', label: 'Black' },
    { value: 'dark_brown', label: 'Dark Brown' },
    { value: 'brown', label: 'Brown' },
    { value: 'light_brown', label: 'Light Brown' },
    { value: 'golden_brown', label: 'Golden Brown' },

    { value: 'dark_blonde', label: 'Dark Blonde' },
    { value: 'blonde', label: 'Blonde' },
    { value: 'light_blonde', label: 'Light Blonde' },
    { value: 'platinum_blonde', label: 'Platinum Blonde' },

    { value: 'auburn', label: 'Auburn' },
    { value: 'red', label: 'Red' },
    { value: 'strawberry_blonde', label: 'Strawberry Blonde' },

    { value: 'gray', label: 'Gray' },
    { value: 'silver', label: 'Silver' },
    { value: 'white', label: 'White' },

    { value: 'ashy_brown', label: 'Ashy Brown' },
    { value: 'ashy_blonde', label: 'Ashy Blonde' },

    { value: 'blue', label: 'Blue' },
    { value: 'dark_blue', label: 'Dark Blue' },
    { value: 'light_blue', label: 'Light Blue' },
    { value: 'purple', label: 'Purple' },
    { value: 'dark_purple', label: 'Dark Purple' },
    { value: 'violet', label: 'Violet' },
    { value: 'pink', label: 'Pink' },
    { value: 'hot_pink', label: 'Hot Pink' },
    { value: 'pastel_pink', label: 'Pastel Pink' },
    { value: 'red_wine', label: 'Red Wine' },
    { value: 'burgundy', label: 'Burgundy' },
    { value: 'orange', label: 'Orange' },
    { value: 'green', label: 'Green' },
    { value: 'dark_green', label: 'Dark Green' },
    { value: 'neon_green', label: 'Neon Green' },
    { value: 'teal', label: 'Teal' },
    { value: 'turquoise', label: 'Turquoise' },
    { value: 'rainbow', label: 'Rainbow' },

    { value: 'ombré', label: 'Ombré' },
    { value: 'balayage', label: 'Balayage' },
    { value: 'highlights', label: 'Highlights' },
    { value: 'lowlights', label: 'Lowlights' },
    { value: 'shatush', label: 'Shatush' },
    { value: 'salt_and_pepper', label: 'Salt and Pepper' },

    { value: 'other', label: 'Other / Miscellaneous' }
];


// export const ethnicityOptions = [
//     { value: 'caucasian', label: 'Caucasian' },
//     { value: 'african', label: 'African' },
//     { value: 'afro-caribbean', label: 'Afro-Caribbean' },
//     { value: 'asian', label: 'Asian' },
//     { value: 'south-asian', label: 'South Asian' },
//     { value: 'east-asian', label: 'East Asian' },
//     { value: 'southeast-asian', label: 'Southeast Asian' },
//     { value: 'hispanic', label: 'Hispanic' },
//     { value: 'latino', label: 'Latino' },
//     { value: 'middle-eastern', label: 'Middle Eastern' },
//     { value: 'north-african', label: 'North African' },
//     { value: 'sub-saharan-african', label: 'Sub-Saharan African' },
//     { value: 'native-american', label: 'Native American' },
//     { value: 'alaskan-native', label: 'Alaskan Native' },
//     { value: 'pacific-islander', label: 'Pacific Islander' },
//     { value: 'melanesian', label: 'Melanesian' },
//     { value: 'micronesian', label: 'Micronesian' },
//     { value: 'polynesian', label: 'Polynesian' },
//     { value: 'romani', label: 'Romani' },
//     { value: 'gypsy', label: 'Gypsy' },
//     { value: 'ashkenazi-jewish', label: 'Ashkenazi Jewish' },
//     { value: 'sefardic-jewish', label: 'Sefardic Jewish' },
//     { value: 'bedouin', label: 'Bedouin' },
//     { value: 'berber', label: 'Berber' },
//     { value: 'mixed', label: 'Mixed' },
//     { value: 'unknown', label: 'Unknown' },
//     { value: 'other', label: 'Other / Miscellaneous' }
// ];

export const ethnicityOptions = [
    { value: 'afghan', label: 'Afghan' },
    { value: 'albanian', label: 'Albanian' },
    { value: 'algerian', label: 'Algerian' },
    { value: 'andorran', label: 'Andorran' },
    { value: 'angolan', label: 'Angolan' },
    { value: 'antiguan', label: 'Antiguan and Barbudan' },
    { value: 'argentine', label: 'Argentine' },
    { value: 'armenian', label: 'Armenian' },
    { value: 'australian', label: 'Australian' },
    { value: 'austrian', label: 'Austrian' },
    { value: 'azerbaijani', label: 'Azerbaijani' },
    { value: 'bahamian', label: 'Bahamian' },
    { value: 'bahraini', label: 'Bahraini' },
    { value: 'bangladeshi', label: 'Bangladeshi' },
    { value: 'barbadian', label: 'Barbadian' },
    { value: 'belarusian', label: 'Belarusian' },
    { value: 'belgian', label: 'Belgian' },
    { value: 'belizean', label: 'Belizean' },
    { value: 'beninese', label: 'Beninese' },
    { value: 'bhutanese', label: 'Bhutanese' },
    { value: 'bolivian', label: 'Bolivian' },
    { value: 'bosnian', label: 'Bosnian' },
    { value: 'botswanan', label: 'Botswanan' },
    { value: 'brazilian', label: 'Brazilian' },
    { value: 'british', label: 'British' },
    { value: 'bruneian', label: 'Bruneian' },
    { value: 'bulgarian', label: 'Bulgarian' },
    { value: 'burkinabe', label: 'Burkinabe' },
    { value: 'burmese', label: 'Burmese' },
    { value: 'burundian', label: 'Burundian' },
    { value: 'cambodian', label: 'Cambodian' },
    { value: 'cameroonian', label: 'Cameroonian' },
    { value: 'canadian', label: 'Canadian' },
    { value: 'cape verdean', label: 'Cape Verdean' },
    { value: 'central african', label: 'Central African' },
    { value: 'chilean', label: 'Chilean' },
    { value: 'chinese', label: 'Chinese' },
    { value: 'colombian', label: 'Colombian' },
    { value: 'comorian', label: 'Comorian' },
    { value: 'congolese', label: 'Congolese' },
    { value: 'costarican', label: 'Costa Rican' },
    { value: 'croatian', label: 'Croatian' },
    { value: 'cuban', label: 'Cuban' },
    { value: 'cypriot', label: 'Cypriot' },
    { value: 'czech', label: 'Czech' },
    { value: 'danish', label: 'Danish' },
    { value: 'djiboutian', label: 'Djiboutian' },
    { value: 'dominican', label: 'Dominican' },
    { value: 'dominican-republic', label: 'Dominican Republic' },
    { value: 'dutch', label: 'Dutch' },
    { value: 'ecuadorian', label: 'Ecuadorian' },
    { value: 'egyptian', label: 'Egyptian' },
    { value: 'salvadoran', label: 'Salvadoran' },
    { value: 'equatorial-guinean', label: 'Equatorial Guinean' },
    { value: 'eritrean', label: 'Eritrean' },
    { value: 'estonian', label: 'Estonian' },
    { value: 'ethiopian', label: 'Ethiopian' },
    { value: 'fijian', label: 'Fijian' },
    { value: 'filipino', label: 'Filipino' },
    { value: 'finnish', label: 'Finnish' },
    { value: 'french', label: 'French' },
    { value: 'gabonese', label: 'Gabonese' },
    { value: 'gambian', label: 'Gambian' },
    { value: 'georgian', label: 'Georgian' },
    { value: 'german', label: 'German' },
    { value: 'ghanaian', label: 'Ghanaian' },
    { value: 'greek', label: 'Greek' },
    { value: 'grenadian', label: 'Grenadian' },
    { value: 'guatemalan', label: 'Guatemalan' },
    { value: 'guinean', label: 'Guinean' },
    { value: 'guyanese', label: 'Guyanese' },
    { value: 'haitian', label: 'Haitian' },
    { value: 'honduran', label: 'Honduran' },
    { value: 'hungarian', label: 'Hungarian' },
    { value: 'icelandic', label: 'Icelandic' },
    { value: 'indian', label: 'Indian' },
    { value: 'indonesian', label: 'Indonesian' },
    { value: 'iranian', label: 'Iranian' },
    { value: 'iraqi', label: 'Iraqi' },
    { value: 'irish', label: 'Irish' },
    { value: 'israeli', label: 'Israeli' },
    { value: 'italian', label: 'Italian' },
    { value: 'jamaican', label: 'Jamaican' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'jordanian', label: 'Jordanian' },
    { value: 'kazakh', label: 'Kazakh' },
    { value: 'kenyan', label: 'Kenyan' },
    { value: 'kiribati', label: 'Kiribati' },
    { value: 'kosovar', label: 'Kosovar' },
    { value: 'kuwaiti', label: 'Kuwaiti' },
    { value: 'kyrgyz', label: 'Kyrgyz' },
    { value: 'laotian', label: 'Laotian' },
    { value: 'latvian', label: 'Latvian' },
    { value: 'lebanese', label: 'Lebanese' },
    { value: 'liberian', label: 'Liberian' },
    { value: 'libyan', label: 'Libyan' },
    { value: 'liechtenstein', label: 'Liechtenstein' },
    { value: 'lithuanian', label: 'Lithuanian' },
    { value: 'luxembourgish', label: 'Luxembourgish' },
    { value: 'macedonian', label: 'Macedonian' },
    { value: 'malagasy', label: 'Malagasy' },
    { value: 'malawian', label: 'Malawian' },
    { value: 'malaysian', label: 'Malaysian' },
    { value: 'maldivian', label: 'Maldivian' },
    { value: 'malian', label: 'Malian' },
    { value: 'marshallese', label: 'Marshallese' },
    { value: 'mauritian', label: 'Mauritian' },
    { value: 'mexican', label: 'Mexican' },
    { value: 'micronesian', label: 'Micronesian' },
    { value: 'moldovan', label: 'Moldovan' },
    { value: 'monacan', label: 'Monacan' },
    { value: 'mongolian', label: 'Mongolian' },
    { value: 'moroccan', label: 'Moroccan' },
    { value: 'mozambican', label: 'Mozambican' },
    { value: 'namibian', label: 'Namibian' },
    { value: 'nauruan', label: 'Nauruan' },
    { value: 'nepalese', label: 'Nepalese' },
    { value: 'new-zealander', label: 'New Zealander' },
    { value: 'nicaraguan', label: 'Nicaraguan' },
    { value: 'nigerian', label: 'Nigerian' },
    { value: 'niuean', label: 'Niuean' },
    { value: 'norwegian', label: 'Norwegian' },
    { value: 'oman', label: 'Omani' },
    { value: 'pakistani', label: 'Pakistani' },
    { value: 'palauan', label: 'Palauan' },
    { value: 'panamanian', label: 'Panamanian' },
    { value: 'papua-new-guinean', label: 'Papua New Guinean' },
    { value: 'paraguayan', label: 'Paraguayan' },
    { value: 'peruvian', label: 'Peruvian' },
    { value: 'philippine', label: 'Philippine' },
    { value: 'polish', label: 'Polish' },
    { value: 'portuguese', label: 'Portuguese' },
    { value: 'qatari', label: 'Qatari' },
    { value: 'romanian', label: 'Romanian' },
    { value: 'russian', label: 'Russian' },
    { value: 'rwandan', label: 'Rwandan' },
    { value: 'saint-lucian', label: 'Saint Lucian' },
    { value: 'salvadoran', label: 'Salvadoran' },
    { value: 'samoan', label: 'Samoan' },
    { value: 'sao-tomean', label: 'São Tomean' },
    { value: 'saudi', label: 'Saudi Arabian' },
    { value: 'senegalese', label: 'Senegalese' },
    { value: 'serbian', label: 'Serbian' },
    { value: 'seychellois', label: 'Seychellois' },
    { value: 'sierra-leonean', label: 'Sierra Leonean' },
    { value: 'singaporean', label: 'Singaporean' },
    { value: 'slovak', label: 'Slovak' },
    { value: 'slovenian', label: 'Slovenian' },
    { value: 'solomon-islander', label: 'Solomon Islander' },
    { value: 'somali', label: 'Somali' },
    { value: 'south-african', label: 'South African' },
    { value: 'south-korean', label: 'South Korean' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'sri-lankan', label: 'Sri Lankan' },
    { value: 'sudanese', label: 'Sudanese' },
    { value: 'surinamese', label: 'Surinamese' },
    { value: 'swazi', label: 'Swazi' },
    { value: 'swedish', label: 'Swedish' },
    { value: 'swiss', label: 'Swiss' },
    { value: 'syrian', label: 'Syrian' },
    { value: 'taiwanese', label: 'Taiwanese' },
    { value: 'tajik', label: 'Tajik' },
    { value: 'tanzanian', label: 'Tanzanian' },
    { value: 'thai', label: 'Thai' },
    { value: 'togolese', label: 'Togolese' },
    { value: 'tongan', label: 'Tongan' },
    { value: 'trinidadian', label: 'Trinidadian' },
    { value: 'tunisian', label: 'Tunisian' },
    { value: 'turkish', label: 'Turkish' },
    { value: 'tuvaluan', label: 'Tuvaluan' },
    { value: 'ugandan', label: 'Ugandan' },
    { value: 'ukrainian', label: 'Ukrainian' },
    { value: 'uruguayan', label: 'Uruguayan' },
    { value: 'uzbek', label: 'Uzbek' },
    { value: 'vanuatu', label: 'Vanuatuan' },
    { value: 'venezuelan', label: 'Venezuelan' },
    { value: 'vietnamese', label: 'Vietnamese' },
    { value: 'yemeni', label: 'Yemeni' },
    { value: 'zambian', label: 'Zambian' },
    { value: 'zimbabwean', label: 'Zimbabwean' },

    { value: 'mixed', label: 'Mixed' },
    { value: 'unknown', label: 'Unknown' },
    { value: 'other', label: 'Other / Miscellaneous' }
];


export const experienceOptions = [
    { value: 'internship', label: 'Internship / Trainee' },
    { value: 'entry-level', label: 'Entry Level (0-2 years)' },
    { value: 'associate', label: 'Associate (2-5 years)' },
    { value: 'mid-level', label: 'Mid Level (5-8 years)' },
    { value: 'senior-level', label: 'Senior Level (8-15 years)' },
    { value: 'executive', label: 'Executive (15+ years)' },
    { value: 'director', label: 'Director / Leadership' },
    { value: 'freelancer', label: 'Freelancer / Consultant' },
    { value: 'owner', label: 'Business Owner' },
    { value: 'team-lead', label: 'Team Lead / Manager' },
    { value: 'experienced', label: 'Experienced Worker (e.g., Chef, Waiter)' },
    { value: 'student-primary', label: 'Primary School (Elementary)' },
    { value: 'student-secondary', label: 'Secondary School (Middle/High School)' },
    { value: 'student-college', label: 'College / University' },
    { value: 'other', label: 'Other' }
];


export const industryOptions = [
    { value: 'technology', label: 'Technology / IT' },
    { value: 'finance', label: 'Finance / Banking / Investment' },
    { value: 'healthcare', label: 'Healthcare / Medical' },
    { value: 'education', label: 'Education / Training' },
    { value: 'construction', label: 'Construction / Real Estate' },
    { value: 'retail', label: 'Retail / E-commerce' },
    { value: 'hospitality', label: 'Hospitality / Tourism' },
    { value: 'transportation', label: 'Transportation / Logistics' },
    { value: 'media', label: 'Media / Entertainment' },
    { value: 'government', label: 'Government / Public Sector' },
    { value: 'nonprofit', label: 'Nonprofit / NGO' },
    { value: 'manufacturing', label: 'Manufacturing / Engineering' },
    { value: 'agriculture', label: 'Agriculture / Farming' },
    { value: 'energy', label: 'Energy / Utilities' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'legal', label: 'Legal' },
    { value: 'telecommunications', label: 'Telecommunications' },
    { value: 'fashion', label: 'Fashion / Apparel' },
    { value: 'arts', label: 'Arts / Culture' },
    { value: 'sports', label: 'Sports / Recreation' },
    { value: 'cleaning-services', label: 'Cleaning / Domestic Services' },
    { value: 'transportation-services', label: 'Transportation Services' },
    { value: 'retail-services', label: 'Retail Services' },
    { value: 'foodservice', label: 'Food Service / Catering' },
    { value: 'event-planning', label: 'Event Planning / Party Planner' },
    { value: 'Entertainment', label: 'Music / Performing Arts' },
    { value: 'personal-training', label: 'Personal Training / Fitness' },
    { value: 'tutoring', label: 'Tutoring / Teaching' },
    { value: 'caregiving', label: 'Caregiving / Home Assistance' },
    { value: 'other', label: 'Other / Miscellaneous' }
];


export const employmentStatusOptions = [
    { value: 'full-time', label: 'Full-Time' },
    { value: 'part-time', label: 'Part-Time' },
    { value: 'contract', label: 'Contract' },
    { value: 'freelance', label: 'Freelance' },
    { value: 'unemployed', label: 'Unemployed' },
    { value: 'self-employed', label: 'Self-Employed' },
    { value: 'intern', label: 'Intern' },
    { value: 'temporary', label: 'Temporary' },
    { value: 'apprenticeship', label: 'Apprenticeship' },
    { value: 'retired', label: 'Retired' },
    { value: 'student', label: 'Student' },
    { value: 'other', label: 'Other' }
];

export const hobbiesOptions = [
    { value: 'reading', label: 'Reading' },
    { value: 'traveling', label: 'Traveling' },
    { value: 'cooking', label: 'Cooking' },
    { value: 'sports', label: 'Sports' },
    { value: 'music', label: 'Music' },
    { value: 'art', label: 'Art and Painting' },
    { value: 'photography', label: 'Photography' },
    { value: 'gaming', label: 'Gaming' },
    { value: 'writing', label: 'Writing' },
    { value: 'yoga', label: 'Yoga' },
    { value: 'gardening', label: 'Gardening' },
    { value: 'volunteering', label: 'Volunteering' },
    { value: 'movies', label: 'Watching Movies' },
    { value: 'technology', label: 'Technology and Gadgets' },
    { value: 'fashion', label: 'Fashion and Styling' },
    { value: 'collecting', label: 'Collecting (e.g., stamps, coins)' },
    { value: 'dancing', label: 'Dancing' },
    { value: 'fitness', label: 'Fitness and Workout' },
    { value: 'crafts', label: 'Crafts (DIY projects)' },
    { value: 'fishing', label: 'Fishing' },
    { value: 'hiking', label: 'Hiking / Outdoors' },
    { value: 'baking', label: 'Baking' },
    { value: 'birdwatching', label: 'Birdwatching' },
    { value: 'podcasting', label: 'Podcasting' },
    { value: 'camping', label: 'Camping' },
    { value: 'motorcycling', label: 'Motorcycling' },
    { value: 'astronomy', label: 'Astronomy' },
    { value: 'coding', label: 'Coding / Programming' },
    { value: 'boardgames', label: 'Board Games' },
    { value: 'scrapbooking', label: 'Scrapbooking / Collage' },
    { value: 'crochet', label: 'Crochet' },
    { value: 'videography', label: 'Videography' },
    { value: 'design', label: 'Graphic Design / Interior etc.' }
];


export const speakingStyleOptions = [
    { value: 'formal', label: 'Formal' },
    { value: 'informal', label: 'Informal' },
    { value: 'humorous', label: 'Humorous' },
    { value: 'direct', label: 'Direct' },
    { value: 'indirect', label: 'Indirect' },
    { value: 'sarcastic', label: 'Sarcastic' },
    { value: 'cheerful', label: 'Cheerful' },
    { value: 'calm', label: 'Calm' },
    { value: 'energetic', label: 'Energetic' },
    { value: 'monotone', label: 'Monotone' },
    { value: 'dramatic', label: 'Dramatic' },
    { value: 'empathetic', label: 'Empathetic' },
    { value: 'assertive', label: 'Assertive' },
    { value: 'reserved', label: 'Reserved' },
    { value: 'inquisitive', label: 'Inquisitive' },
    { value: 'optimistic', label: 'Optimistic' },
    { value: 'confident', label: 'Confident' },
    { value: 'romantic', label: 'Romantic' },
    { value: 'supportive', label: 'Supportive' },
    { value: 'playful', label: 'Playful' },
    { value: 'thoughtful', label: 'Thoughtful' },
];




